import React from "react";
import { connect } from "react-redux";
import Pov from "src/components/Pov";
import * as State from "src/redux/projects/state";
import * as StateCurrentResponses from "src/redux/currentResponses/state";
import * as CurrentReponses from "src/redux/currentResponses";
import { Profil } from "src/redux/user";

interface Props {
  proposal: State.ProposalPOV;
  currentResponses: StateCurrentResponses.CurrentResponse[];
  prestationId: number;
  projectId: number;
  prestationName: string;
  projectName: string;
  profil: Profil;
  handleSubmitProposal: (response: State.GenericalResponse | undefined) => void;
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentProposalResponseForPov: (
      proposalUuid: string,
      ressourceId: number,
      comment: string
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseForPov(
          proposalUuid,
          ressourceId,
          comment
        )
      ),
    setCurrentProposalResponseType: (
      proposalUuid: string,
      responseType: State.ResponseTypes
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseType(
          proposalUuid,
          responseType
        )
      ),
    createEmptyPovResponse: (proposalUuid: string) =>
      dispatch(CurrentReponses.createEmptyPovResponse(proposalUuid))
  };
}

type PropsWithMapState = ReturnType<typeof mapDispatchToProps> & Props;
interface State {
  isLocked: boolean;
}

class PovContainerToConnect extends React.Component<PropsWithMapState> {
  state: State = {
    isLocked: this.props.proposal.status !== State.ProposalStatus.Pending
  };

  componentWillMount() {
    if (
      !this.getResponse() &&
      this.props.proposal.status === State.ProposalStatus.Pending
    ) {
      this.props.createEmptyPovResponse(this.props.proposal.uuid);
    }
  }
  getResponse() {
    const currentResponse = this.props.currentResponses.find(
      r => r.proposalUuid === this.props.proposal.uuid
    );

    return currentResponse;
  }

  onIndexChange = (value: number) => {
    if (value === -1) {
      history.back();
    }
    this.setState({
      step: value
    });
  };

  setCurrentProposalResponseForPov = (
    proposalUuid: string,
    ressourceId: number,
    comment: string
  ) => {
    if (this.state.isLocked) {
      return;
    }
    this.props.setCurrentProposalResponseForPov(
      proposalUuid,
      ressourceId,
      comment
    );
  };

  setCurrentProposalResponseType = (
    proposalUuid: string,
    responseType: State.ResponseTypes
  ) => {
    if (this.state.isLocked) {
      return;
    }

    this.props.setCurrentProposalResponseType(proposalUuid, responseType);
  };

  renderDisplayComponent() {
    return (
      <Pov
        proposal={this.props.proposal}
        response={this.getResponse()}
        setCurrentProposalResponseForPov={this.setCurrentProposalResponseForPov}
        projectName={this.props.projectName}
        prestationName={this.props.prestationName}
        setCurrentProposalResponseType={this.setCurrentProposalResponseType}
        isLocked={this.state.isLocked}
        handleSubmitProposal={this.props.handleSubmitProposal}
        profil={this.props.profil}
      />
    );
  }

  render() {
    if (!this.props.proposal) {
      return null;
    }

    return this.renderDisplayComponent();
  }
}

export const PovContainer = connect(
  null,
  mapDispatchToProps
)(PovContainerToConnect);



// WEBPACK FOOTER //
// ./src/containers/PovContainer.tsx